// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.WalletMovements_movements__Md3e7 {
  width: 100%;
  font-family: "Sora", sans-serif;
}
.WalletMovements_movements__header__je5QD {
  margin-bottom: 24px;
  text-align: left;
}
.WalletMovements_movements__eyebrow__xFQX4 {
  display: block;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #82B194;
  margin-bottom: 8px;
}
.WalletMovements_movements__title__4jlxp {
  margin: 0;
  font-size: 24px;
  font-weight: 800;
  color: #13231D;
  letter-spacing: -0.02em;
}
.WalletMovements_movements__table-card__Gdkwv {
  margin-top: 12px;
}

.WalletMovements_status-tag__bFLBu {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border: 1px solid transparent;
}
.WalletMovements_status-tag--in__bcM-h {
  background: #E9F4EF;
  color: #4E997C;
  border-color: #d1e7dd;
}
.WalletMovements_status-tag--out__9o2de {
  background: #FEF2F2;
  color: #C95C5C;
  border-color: #fadbd8;
}

.WalletMovements_text-reference__8gcEP {
  font-weight: 700;
  color: #13231D;
  font-size: 14px;
}

.WalletMovements_text-date__pvp9O {
  font-size: 13px;
  color: rgba(19, 35, 29, 0.68);
  font-weight: 500;
}

.WalletMovements_description-cell__text__8k4bn {
  margin: 0 0 6px 0;
  font-size: 14px;
  color: rgba(19, 35, 29, 0.68);
  line-height: 1.5;
}
.WalletMovements_description-cell__link__YClzT {
  font-size: 12px;
  font-weight: 800;
  color: #82B194;
  text-decoration: none;
}
.WalletMovements_description-cell__link__YClzT:hover {
  text-decoration: underline;
}

.WalletMovements_amount__eSJIS {
  font-size: 15px;
  font-weight: 800;
  white-space: nowrap;
}
.WalletMovements_amount--positive__GVuo1 {
  color: #166534;
}
.WalletMovements_amount--negative__u1sBZ {
  color: #C95C5C;
}

@media (max-width: 1024px) {
  .WalletMovements_movements__title__4jlxp {
    font-size: 22px;
  }
}
@media (max-width: 768px) {
  .WalletMovements_movements__header__je5QD {
    margin-bottom: 20px;
    margin-left: 10px;
  }
  .WalletMovements_movements__title__4jlxp {
    font-size: 20px;
  }
  .WalletMovements_movements__table-card__Gdkwv {
    margin-top: 0;
  }
  .WalletMovements_description-cell__FP\\+Fx {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
    max-width: 60%;
  }
  .WalletMovements_description-cell__text__8k4bn {
    font-size: 13px;
    margin-bottom: 4px;
  }
  .WalletMovements_text-reference__8gcEP {
    font-size: 13px;
    max-width: 60%;
    text-align: right;
  }
  .WalletMovements_text-date__pvp9O {
    font-size: 12px;
  }
  .WalletMovements_amount__eSJIS {
    font-size: 14px;
  }
  .WalletMovements_status-tag__bFLBu {
    min-height: 24px;
    font-size: 10px;
    padding: 0 10px;
  }
}
@media (max-width: 480px) {
  .WalletMovements_movements__title__4jlxp {
    font-size: 18px;
  }
  .WalletMovements_description-cell__FP\\+Fx, .WalletMovements_text-reference__8gcEP {
    max-width: 100%;
  }
  .WalletMovements_amount__eSJIS {
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/Wallet/WalletMovements/WalletMovements.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AARA;EACE,WAAA;EACA,+BAAA;AAWF;AATE;EACE,mBAAA;EACA,gBAAA;AAWJ;AARE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDZmB;ECanB,kBAAA;AAUJ;AAPE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cDPmB;ECQnB,uBAAA;AASJ;AANE;EACI,gBAAA;AAQN;;AAHA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,6BAAA;AAMJ;AAJI;EACI,mBAAA;EACA,cAAA;EACA,qBAAA;AAMR;AAHI;EACI,mBAAA;EACA,cAAA;EACA,qBAAA;AAKR;;AADA;EACI,gBAAA;EACA,cD7CmB;EC8CnB,eAAA;AAIJ;;AADA;EACI,eAAA;EACA,6BDjDmB;ECkDnB,gBAAA;AAIJ;;AAAI;EACI,iBAAA;EACA,eAAA;EACA,6BDzDe;EC0Df,gBAAA;AAGR;AAAI;EACI,eAAA;EACA,gBAAA;EACA,cD/Ee;ECgFf,qBAAA;AAER;AAAQ;EACI,0BAAA;AAEZ;;AAGA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;AAEI;EACI,cAAA;AAAR;AAGI;EACI,cD/Ee;AC8EvB;;AAMA;EAEQ;IACI,eAAA;EAJV;AACF;AAQA;EAEQ;IACI,mBAAA;IACA,iBAAA;EAPV;EAUM;IACI,eAAA;EARV;EAWM;IACI,aAAA;EATV;EAaE;IACI,aAAA;IACA,sBAAA;IACA,qBAAA;IACA,iBAAA;IACA,cAAA;EAXN;EAaM;IACI,eAAA;IACA,kBAAA;EAXV;EAeE;IACI,eAAA;IACA,cAAA;IACA,iBAAA;EAbN;EAgBE;IACI,eAAA;EAdN;EAiBE;IACI,eAAA;EAfN;EAkBE;IACI,gBAAA;IACA,eAAA;IACA,eAAA;EAhBN;AACF;AAmBA;EAEQ;IACI,eAAA;EAlBV;EAsBE;IACI,eAAA;EApBN;EAuBE;IACI,eAAA;EArBN;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n$bw-primary: $color-primary;\n$bw-error: $color-error;\n$bw-text: $text-main;\n$bw-muted: $text-secondary;\n$bw-border: $color-border;\n\n.movements {\n  width: 100%;\n  font-family: \"Sora\", sans-serif;\n\n  &__header {\n    margin-bottom: 24px;\n    text-align: left;\n  }\n\n  &__eyebrow {\n    display: block;\n    font-size: 11px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.14em;\n    color: $bw-primary;\n    margin-bottom: 8px;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 800;\n    color: $bw-text;\n    letter-spacing: -0.02em;\n  }\n\n  &__table-card {\n      margin-top: 12px;\n  }\n}\n\n\n.status-tag {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 28px;\n    padding: 0 12px;\n    border-radius: 999px; \n    font-size: 11px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    border: 1px solid transparent;\n\n    &--in {\n        background: #E9F4EF;\n        color: #4E997C;\n        border-color: #d1e7dd;\n    }\n\n    &--out {\n        background: #FEF2F2;\n        color: #C95C5C;\n        border-color: #fadbd8;\n    }\n}\n\n.text-reference {\n    font-weight: 700;\n    color: $bw-text;\n    font-size: 14px;\n}\n\n.text-date {\n    font-size: 13px;\n    color: $bw-muted;\n    font-weight: 500;\n}\n\n.description-cell {\n    &__text {\n        margin: 0 0 6px 0;\n        font-size: 14px;\n        color: $bw-muted;\n        line-height: 1.5;\n    }\n\n    &__link {\n        font-size: 12px;\n        font-weight: 800;\n        color: $bw-primary;\n        text-decoration: none;\n        \n        &:hover {\n            text-decoration: underline;\n        }\n    }\n}\n\n.amount {\n    font-size: 15px;\n    font-weight: 800;\n    white-space: nowrap;\n\n    &--positive {\n        color: #166534;\n    }\n\n    &--negative {\n        color: $bw-error;\n    }\n}\n\n\n@media (max-width: 1024px) {\n    .movements {\n        &__title {\n            font-size: 22px;\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .movements {\n        &__header {\n            margin-bottom: 20px;\n            margin-left: 10px;\n        }\n\n        &__title {\n            font-size: 20px;\n        }\n\n        &__table-card {\n            margin-top: 0;\n        }\n    }\n\n    .description-cell {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        text-align: right;\n        max-width: 60%;\n\n        &__text {\n            font-size: 13px;\n            margin-bottom: 4px;\n        }\n    }\n\n    .text-reference {\n        font-size: 13px;\n        max-width: 60%;\n        text-align: right;\n    }\n\n    .text-date {\n        font-size: 12px;\n    }\n\n    .amount {\n        font-size: 14px;\n    }\n\n    .status-tag {\n        min-height: 24px;\n        font-size: 10px;\n        padding: 0 10px;\n    }\n}\n\n@media (max-width: 480px) {\n    .movements {\n        &__title {\n            font-size: 18px;\n        }\n    }\n\n    .description-cell, .text-reference {\n        max-width: 100%;\n    }\n\n    .amount {\n        font-size: 11px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"movements": `WalletMovements_movements__Md3e7`,
	"movements__header": `WalletMovements_movements__header__je5QD`,
	"movements__eyebrow": `WalletMovements_movements__eyebrow__xFQX4`,
	"movements__title": `WalletMovements_movements__title__4jlxp`,
	"movements__table-card": `WalletMovements_movements__table-card__Gdkwv`,
	"status-tag": `WalletMovements_status-tag__bFLBu`,
	"status-tag--in": `WalletMovements_status-tag--in__bcM-h`,
	"status-tag--out": `WalletMovements_status-tag--out__9o2de`,
	"text-reference": `WalletMovements_text-reference__8gcEP`,
	"text-date": `WalletMovements_text-date__pvp9O`,
	"description-cell__text": `WalletMovements_description-cell__text__8k4bn`,
	"description-cell__link": `WalletMovements_description-cell__link__YClzT`,
	"amount": `WalletMovements_amount__eSJIS`,
	"amount--positive": `WalletMovements_amount--positive__GVuo1`,
	"amount--negative": `WalletMovements_amount--negative__u1sBZ`,
	"description-cell": `WalletMovements_description-cell__FP+Fx`
};
export default ___CSS_LOADER_EXPORT___;
